import { faKey } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@vapor/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import DialogHoauGrid from './dialog-hoau-grid'

export default function ButtonHoauGrid({ tenantId, propertyId, reservationId }: { tenantId: string; propertyId: string; reservationId: string }) {
  const { t } = useTranslation()
  const [openHoauGrid, setOpenHoauGrid] = useState(false)

  return (
    <>
      <Button
        variant="outlined"
        size="small"
        startIcon={<FontAwesomeIcon icon={faKey} />}
        onClick={() => {
          setOpenHoauGrid(true)
        }}
      >
        {t('pms.booking.reservation.hoau.open')}
      </Button>
      {openHoauGrid && (
        <DialogHoauGrid
          open={openHoauGrid}
          onClose={() => {
            setOpenHoauGrid(false)
          }}
          tenantId={tenantId}
          propertyId={propertyId}
          reservationId={reservationId}
        />
      )}
    </>
  )
}
